const Menu = [
  {
    title: 'DASHBOARD',
    //group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    otherPermissions:['forImr'],
    items: [
      { name: 'Dashboard', title: 'DASHBOARD', slug: 'dashboard', is_module: false, component: 'Dashboard',},
      { name: 'MpCodesList', title: 'MY MP CODES', slug: 'mp_codes',is_module: true, component:'MpCodesList'},
    ]
  },
  {
    title: 'IMR CODES',
    //group: 'apps',
    icon: 'mail',
    name: 'IMR CODES',
    otherPermissions:['forImr'],
    items: [
      { name: 'ImrList', title: 'MY IMR CODES', slug: 'imr',is_module: true, component:'ImrList'},
      { name: 'Invite User', title: 'INVITE USER', slug: 'imr',is_module: true, component:'InviteUser'},
    ]
  },
  {
    title: 'CARRIER',
    icon: 'local_shipping',
    name: 'Carrier',
    otherPermissions:['forImr'],
    items: 
    process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'development' ?
    [
      { name: 'POST TRUCK', is_module: true, title: 'POST TRUCK', component: 'AddTruck', slug: 'trucks', forAddEdit:true },
      { name: 'MY TRUCKS', is_module: true, title: 'MY TRUCKS', component: 'Trucks', slug: 'trucks' },
      { name: 'LOAD SEARCH', is_module: true, title: 'LOAD SEARCH', component: 'SearchLoads', slug: 'load_searches' },
      { name: 'FAST POSTS', is_module: true, title: 'FASTPOST', component: 'TruckFastPost', slug: 'trucks', forAddEdit: true}
    ]
    :
    [
      { name: 'POST TRUCK', is_module: true, title: 'POST TRUCK', component: 'AddTruck', slug: 'trucks', forAddEdit:true },
      { name: 'MY TRUCKS', is_module: true, title: 'MY TRUCKS', component: 'Trucks', slug: 'trucks' },
      { name: 'LOAD SEARCH', is_module: true, title: 'LOAD SEARCH', component: 'SearchLoads', slug: 'load_searches' },
    ]
  },
  {
    title: 'BROKER/SHIPPER',
    icon: 'fa-cube',
    name: 'Broker/Shipper',
    otherPermissions:['forImr'],
    items: [
      { name: 'POST LOAD', is_module: true, title: 'POST LOAD', component: 'AddLoad', slug: 'loads', forAddEdit:true },
      { name: 'MY LOADS', is_module: true, title: 'MY LOADS', component: 'Loads', slug: 'loads' },
      { name: 'TRUCK SEARCH', is_module: true, title: 'TRUCK SEARCH', component: 'SearchTrucks', slug: 'truck_searches' },
      { name: 'AUTOLOADER', is_module: true, title: 'AUTOLOADER', slug: 'autoloader', component: 'AutoLoader' },
      { name: 'FAST POSTS', is_module: true, title: 'FASTPOST', component: 'FastPost', slug: 'loads', forAddEdit: true}
    ]
  },
  {
    title: 'DOCUMENTS',
    group: 'apps',
    icon: 'description',
    name: 'DocumentsList',
    otherPermissions:['forImr'],
    slug: 'documents',
    is_module: false,
  },
  {
    title: 'COMMUNITY',
    otherPermissions:[],
    group: 'apps',
    icon: 'forum',
    items: [
      // { name: 'MAXTALKS', title: 'MAXTALKS', href:'https://forum.loadmax.com', target: '_blank' },
      { name: 'MAXNEWS', title: 'MAXNEWS', href:'https://loadmax.com/news', target: '_blank' },
      { name: 'MAXCARES', title: 'LOADMAXCARES', href:'https://loadmaxcares.com', target: '_blank' }
    ]
  },
  {
    title: 'RESOURCES',
    group: 'apps',
    icon: 'star',
    name: 'resource',
    otherPermissions:[],
    slug: 'resources'
  },
  // {
  //   title: 'IMR CODES',
  //   group: 'apps',
  //   icon: 'description',
  //   name: 'ImrList',
  //   slug: 'imr',
  //   is_module: true,
  // },
  // {
  //   title: 'CODE CREATING',
  //   group: 'apps',
  //   icon: 'description',
  //   name: 'MpCodesList',
  //   slug: 'MpCodesList',
  //   // is_module: true,
  // },
  // {
  //   divider: true
  // },
  {
    title: 'CHATBOT',
    group: 'apps',
    icon: 'fa-comment',
    name: 'Chatbot',
    otherPermissions:['forImr'],
    slug: 'chatbot',
    forSuperAdmin:true,
    is_module: false,
  },
  {
    title: 'BULK EMAIL',
    group: 'apps',
    icon: 'fa-paper-plane',
    name: 'AddEmailBroadcast',
    otherPermissions:['forImr'],
    slug: 'AddEmailBroadcast',
    forSuperAdmin:true,
    is_module: false,
  },
  {
    title: 'PROFILE',
    icon: 'person',
    name: 'profile',
    otherPermissions:['forImr'],
    items: [
      { name: 'PROFILE',title: 'PROFILE', component: 'PROFILE', slug: 'profile'},
      { name: 'ACCOUNT', title: 'ACCOUNT', component: 'ACCOUNT', slug: 'account' },
    ]
  },
  {
    title: 'REPORTING',
    icon: 'trending_up',
    name: 'ComingSoon',
    otherPermissions:['forImr'],
    items: [
      { name: 'Users', is_module: true, title: 'USERS', slug: 'users', component: 'Users' },
      { name: 'Imr Users', is_module: true, title: 'MAX MARKETING USERS', slug: 'imr_users', component: 'ImrUsers' },
      { name: 'User Profiles', is_module: true, title: 'USER PROFILES', slug: 'user_profiles', component: 'Roles' },
      { name: 'Equipment Types', is_module: true, slug: 'equipments', title: 'EQUIPMENT TYPES', component: 'EquipmentsList' }
    ]
  },
  // {
  //   title: 'HELP',
  //   icon: 'info',
  //   name: 'Help',
  //   otherPermissions:['forImr'],
  //   items: [
  //     { name: 'TUTORIALS', title: 'TUTORIALS', component: 'tutorials', slug: 'tutorials' },
  //     { name: 'FAQs', title: 'FAQs', component: 'faqs', slug: 'faqs' }
  //   ]
  // }
];

if(process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'development'){
  Menu.push({
    title: 'HELP',
    icon: 'info',
    name: 'Help',
    otherPermissions:['forImr'],
    items: [
      { name: 'TUTORIALS', title: 'TUTORIALS', component: 'tutorials', slug: 'tutorials' },
      { name: 'FAQs', title: 'FAQs', component: 'faqs', slug: 'faqs' }
    ]
  })
} else {
  Menu.push({
    title: 'HELP',
    icon: 'info',
    name: 'Help',
    otherPermissions:['forImr'],
    items: [
      { name: 'FAQs', title: 'FAQs', component: 'faqs', slug: 'faqs' }
    ]
  })
}

const imrMenu = [
  {
    title: 'DASHBOARD',
    //group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    otherPermissions:['forImr'],
    items: [
      { name: 'Dashboard', title: 'DASHBOARD', slug: 'dashboard', is_module: false, component: 'Dashboard',},
      { name: 'MpCodesList', title: 'MY MP CODES', slug: 'mp_codes',is_module: true, component:'MpCodesList'},
    ]
  },
  {
    title: 'IMR CODES',
    //group: 'apps',
    icon: 'mail',
    name: 'IMR CODES',
    otherPermissions:['forImr'],
    items: [
      { name: 'ImrList', title: 'MY IMR CODES', slug: 'imr',is_module: true, component:'ImrList'},
      { name: 'Invite User', title: 'INVITE USER', slug: 'imr',is_module: true, component:'InviteUser'},
    ]
  },
  {
    title: 'DOCUMENTS',
    group: 'apps',
    icon: 'description',
    name: 'DocumentsList',
    otherPermissions:['forImr'],
    slug: 'documents',
    is_module: false,
  },
  {
    divider: true
  },
  {
    title: 'PROFILE',
    icon: 'person',
    name: 'profile',
    otherPermissions:['forImr'],
    items: [
      { name: 'PROFILE',title: 'PROFILE', component: 'PROFILE', slug: 'profile'},
      { name: 'ACCOUNT', title: 'ACCOUNT', component: 'ACCOUNT', slug: 'account' },
    ]
  },
  {
    title: 'HELP',
    icon: 'info',
    name: 'Help',
    otherPermissions:['forImr'],
    items: [
      { name: 'FAQs', title: 'FAQs', component: 'faqs', slug: 'faqs' }
    ]
  }
];

export default {Menu,imrMenu};



// WEBPACK FOOTER //
// ./src/api/menu.js